<!-- #18 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add Timesheet
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold">
          Timesheet

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <ul class="text-left mb-2">
            <li>Timesheet data</li>
            <table class="my-table" v-if="stringvalue.length">
              <thead>
                <tr>
                  <th>Employee Role</th>
                  <th>Employee Sub Role</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in stringvalue" :key="index">
                  <td>{{ Object.keys(item)[0] }}</td>
                  <td>{{ Object.values(item)[0] }}</td>
                </tr>
              </tbody>
            </table>
          </ul>
        </v-form>
      </v-card-text>
      <v-divider class="mb-3"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col md="4" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  label="Vendor Name"
                  :items="vendors"
                  v-model="selectedVendor"
                  :rules="[(v) => !!v || 'Vendor name is required.']"
                  class="required mt-0 pt-0"
                  item-text="vendor_name"
                  item-value="id"
                  @focus="getvendorList"
                  @input="getListDetails"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(date)"
                      label="Attendance Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="mt-0 pt-1 pl-3 required"
                      clearable
                      :rules="[(v) => !!v || 'Attendance Date']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    required
                    v-model="date"
                    @change="getListDetails"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="4" class="custom">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  class="required"
                  label="Select your file"
                  :rules="[(v) => !!v || 'Please select  File']"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left mt-0">
              <v-col>
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-2"
                  :loading="downloader"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >
                <v-btn
                  class="ml-3"
                  @click="$router.push('/vendor/timesheet-list')"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
      file-name="HS-Product-Errorlist"
      :other="other"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: {
    BulkErrors,
  },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  mounted() {
    this.getvendorList();
  },
  data() {
    return {
      vendors: [],
      selectedVendor: null,
      productsLoader: false,
      file: null,
      fileLoader: false,
      downloader: false,
      uploadRes: {},
      uploadResDialog: false,
      vendorLoader: false,
      dateMenu: false,
      date: null,
      stringvalue: [],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    ...mapActions([
      "uploadTimesheet",
      "fetchClient",
      "snackBar",
      "getvendorDropdown",
      "downloadListTemplate",
      "getRateCardDetails",
    ]),
    downloadTemplate() {
      this.downloader = true;
      this.downloadListTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    listPage() {
      this.$router.push({
        name: "productStatusList",
        params: {
          type: "product_upload",
        },
      });
    },
    getListDetails() {
      if (this.userCategory.user_category === 3) {
        if (this.date && this.selectedVendor) {
          let data = {
            vendor_id: this.selectedVendor,
            date_of_attendance: this.date,
          };
          this.getRateCardDetails(data).then((res) => {
            this.stringvalue = Object.entries(res.data).map(([key, value]) => {
              const filteredValues = value.filter((val) => val !== null);
              const string =
                filteredValues.length > 0 ? `${filteredValues.join(", ")}` : "";
              return { [key]: string };
            });
          });
        }
      } else {
        if (this.date) {
          let data = {
            date_of_attendance: this.date,
          };
          this.getRateCardDetails(data).then((res) => {
            this.stringvalue = Object.entries(res.data).map(([key, value]) => {
              const filteredValues = value.filter((val) => val !== null);
              const string =
                filteredValues.length > 0 ? `${filteredValues.join(", ")}` : "";
              return { [key]: string };
            });
          });
        }
      }
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      payload.append("date_of_attendance", this.date);

      if (this.userCategory.user_category === 3) {
        payload.append("vendor_id", this.selectedVendor);
      }
      this.uploadTimesheet(payload)
        .then((res) => {
          this.fileLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$refs.form.reset();
          this.uploadRes = res.data;
          this.uploadResDialog = true;
        })
        .catch(() => {
          this.fileLoader = false;
          this.$refs.form.reset();
          this.date = null;
        });
    },

    getvendorList() {
      if (this.vendors.length) return;

      if (this.vendors.length === 0 && this.userCategory.user_category === 3) {
        this.vendorLoader = true;

        this.getvendorDropdown()
          .then((res) => {
            this.vendorLoader = false;
            this.vendors = res.data;
          })
          .catch(() => {
            this.vendorLoader = false;
          });
      }
    },
  },
};
</script>
<style>
.custom .v-text-field {
  padding-top: 0;
}
.my-table {
  border-collapse: collapse;
  width: 50%;
}

.my-table th,
.my-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.my-table th {
  background-color: #f2f2f2;
}
</style>
